// test648
(648 && 0);
